var _defs, _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "prefix__a",
    width: "125%",
    height: "700%",
    x: "-12.5%",
    y: "-300%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 3.24
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeOpacity: 0,
    d: "M0 0H260V260H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#303BA6",
    d: "M65.6 36.2H33.2c-3.97 0-7.2 3.23-7.2 7.2v16.2c0 3.97 3.23 7.2 7.2 7.2h8.76l4.353 7.252C46.965 75.14 48.14 75.8 49.4 75.8c.056 0 .113-.002.173-.004 1.325-.064 2.507-.851 3.078-2.05l3.306-6.946H65.6c3.97 0 7.2-3.23 7.2-7.2V43.4c0-3.97-3.23-7.2-7.2-7.2",
    transform: "translate(29 30)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0AA8F0",
    d: "M87.2 2C83.23 2 80 5.23 80 9.2V47c0 3.97 3.23 7.2 7.2 7.2h30.028l4.464 10.418c.538 1.255 1.738 2.097 3.103 2.177.068.003.137.005.205.005 1.287 0 2.482-.688 3.125-1.814L134.29 54.2h15.91c3.97 0 7.2-3.23 7.2-7.2V9.2c0-3.97-3.23-7.2-7.2-7.2h-63z",
    transform: "translate(29 30)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B0F0FF",
    d: "M137.6 23.6H98c-1.987 0-3.6-1.613-3.6-3.6s1.613-3.6 3.6-3.6h39.6c1.987 0 3.6 1.613 3.6 3.6s-1.613 3.6-3.6 3.6M123.2 38H98c-1.987 0-3.6-1.613-3.6-3.6s1.613-3.6 3.6-3.6h25.2c1.987 0 3.6 1.613 3.6 3.6s-1.613 3.6-3.6 3.6",
    transform: "translate(29 30)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#303BA6",
    stroke: "#2F36A9",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.678 30.802l8.736.44c1.24.061 2.236 1.082 2.212 2.28-.024 1.2-1.06 2.127-2.3 2.065l-8.74-.428c-1.24-.061-2.232-1.094-2.208-2.292.025-1.198 1.06-2.126 2.3-2.065zM10.445 9.09l6.166 6.03c.871.85.895 2.223.06 3.04-.842.83-2.246.8-3.116-.05l-6.166-6.03c-.871-.85-.895-2.222-.06-3.04.842-.83 2.246-.8 3.116.05zM31.74 3.586l.082 8.558c.006 1.216-.964 2.275-2.167 2.344-1.194.077-2.182-.864-2.198-2.07l-.073-8.568c-.015-1.207.955-2.265 2.159-2.334 1.193-.077 2.19.853 2.197 2.07z",
    transform: "translate(29 30) rotate(16 3.212 39.788)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0078DE",
    d: "M144.501 112.691c9.047 0 16.409-7.36 16.409-16.407s-7.362-16.407-16.409-16.407c-9.045 0-16.407 7.36-16.407 16.407s7.362 16.407 16.407 16.407M66.008 112.691c9.045 0 16.407-7.36 16.407-16.407s-7.362-16.407-16.407-16.407c-9.047 0-16.409 7.36-16.409 16.407s7.362 16.407 16.409 16.407M105.191 110.522c11.414 0 20.7-9.286 20.7-20.7s-9.286-20.7-20.7-20.7-20.7 9.286-20.7 20.7 9.286 20.7 20.7 20.7M87.461 114.719h-.016C75.976 115.56 67 125.23 67 136.736v9.148c0 2.848 2.317 5.164 5.165 5.164h65.671c2.848 0 5.164-2.316 5.164-5.164v-9.148c0-11.506-8.976-21.176-20.436-22.016-.041-.004-.12.024-.15.053l-.004.004c-4.689 4.56-10.872 7.071-17.41 7.071s-12.721-2.511-17.41-7.071c-.05-.049-.096-.058-.129-.058M62.286 145.884v-9.148c0-6.522 2.355-12.56 6.272-17.274-.808.112-1.626.189-2.455.189-4.664 0-9.074-1.791-12.42-5.043-.437-.425-1.031-.649-1.649-.602C41.922 114.745 34 123.279 34 133.434v7.25c0 3.349 2.724 6.075 6.076 6.075H62.33c-.024-.289-.044-.58-.044-.875M158.663 114.006c-.604-.038-1.211.177-1.648.602-3.343 3.252-7.757 5.043-12.419 5.043-.88 0-1.746-.084-2.604-.21 3.932 4.716 6.294 10.763 6.294 17.294v9.15c0 .294-.019.585-.044.874h22.383c3.348 0 6.074-2.726 6.074-6.075v-7.25c0-10.156-7.924-18.689-18.036-19.428",
    transform: "translate(29 30)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M127 50L166.6 50M127 64.4L152.2 64.4"
  })), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#4A4F7A",
    opacity: 0.539,
    style: {
      mixBlendMode: "soft-light"
    },
    cx: 133.44,
    cy: 210.24,
    rx: 46.44,
    ry: 3.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#4A4F7A",
    opacity: 0.269,
    style: {
      mixBlendMode: "multiply"
    },
    cx: 133.44,
    cy: 211.32,
    filter: "url(#prefix__a)",
    rx: 38.88,
    ry: 1.62
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSports);
export default __webpack_public_path__ + "static/media/sports.9605de21b1e60994fc57d47c25cd75bd.svg";
export { ForwardRef as ReactComponent };